import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import ListItems from '../common/ListItems';

import { StyledSelect } from 'lib/styles';

const Container = styled.div`
	padding: 16px 40px;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const InputWrapper = styled.div`
	margin: 0 0 2rem;
`;

class Responsibility extends React.Component {
	constructor(props) {
		super(props);
		const data = props.data && props.data.data ? props.data.data : {};
		this.state = {
			sidebar: data.sidebar || 'text',
			logos: data.logos || [],
			items: data.items || [],
			columns: data.columns || '3',
			images: data.images || []
		};
	}

	updateChanges(name, value) {
		this.setState({
			[name]: value
		}, () => {
			this.props.changesHandler({
				sidebar: this.state.sidebar,
				items: this.state.items,
				logos: this.state.logos,
				columns: this.state.columns,
				images: this.state.images,
			}, true);
		});
	}

	render() {
		const {
			t,
			building,
			lng
		} = this.props;

		// Responsibility columns
		const responsibilities = this.props.responsibilities.map(responsibility => {
			return {
				id: responsibility.id,
				name: building.i18n[lng][`responsibility_${responsibility.id}_title`] || responsibility.i18n[lng].name || '',
				icon: responsibility.iconUrl
			};
		});

		// Certificate/logo list
		const buildingCertsArray = building.environment_certificate ? building.environment_certificate.split(',') : [];

		//trim items
		const buildingCerts = buildingCertsArray.map(el => el.trim());

		const logos = this.props.certificates.filter(certificate => {
			return buildingCerts.includes(certificate.name);
		}).map(item => {
			return {
				id: item.id,
				name: item.name,
				icon: item.logoUrl
			};
		});

		// Sidebar images
		const images = building.images.map(image => {
			return {
				id: image.file,
				name: image.name,
				icon: image.conversions.min
			};
		});

		const sidebarOptions = [
			{ value: 'text', name: t('controls/responsibility/sidebar text') },
			{ value: 'image', name: t('controls/responsibility/sidebar image') },
			{ value: 'none', name: t('controls/responsibility/sidebar none') }
		];

		const columnOptions = [
			{ value: '2', name: '2' },
			{ value: '3', name: '3' },
			{ value: '4', name: '4' },
		];

		return (
			<Container>
				<React.Fragment>
					<InputWrapper>
						<Label>{t('controls/responsibility/sidebar options')}</Label>
						<StyledSelect
							options={sidebarOptions}
							id="sidebar-select"
							value={this.state.sidebar}
							onChange={(event) => this.updateChanges('sidebar', event.target.value)}
							style={{ width: '100%' }}
						/>
					</InputWrapper>
					{this.state.sidebar === 'image' && (
						<InputWrapper>
							<ListItems
								value={this.state.images}
								onChange={(value) => this.updateChanges('images', value)}
								labels={{
									select: 'controls/responsibility/select images',
								}}
								onSelect={() => {}}
								items={images}
							/>
						</InputWrapper>
					)}
					<InputWrapper>
						<Label>{t('controls/responsibility/column options')}</Label>
						<StyledSelect
							options={columnOptions}
							id="columns-select"
							value={this.state.columns}
							onChange={(event) => this.updateChanges('columns', event.target.value)}
							style={{ width: '100%' }}
						/>
					</InputWrapper>
					<InputWrapper>
						<ListItems
							value={this.state.items}
							onChange={(value) => this.updateChanges('items', value)}
							labels={{
								select: 'controls/responsibility/select items',
							}}
							onSelect={() => {}}
							items={responsibilities}
						/>
					</InputWrapper>
					<InputWrapper>
						<ListItems
							value={this.state.logos}
							onChange={(value) => this.updateChanges('logos', value)}
							labels={{
								select: 'controls/responsibility/select logos',
							}}
							onSelect={() => {}}
							items={logos}
						/>
					</InputWrapper>
				</React.Fragment>
			</Container>
		)
	}
}

Responsibility.propTypes = {
	t: PropTypes.func,
	data: PropTypes.object,
	building: PropTypes.object,
	unsavedChanges: PropTypes.object,
	viewSettings: PropTypes.bool,
	activeIndex: PropTypes.number,
	viewItems: PropTypes.bool,
	changesHandler: PropTypes.func,
	activeIndexHandler: PropTypes.func,
	viewItemsToggleHandler: PropTypes.func,
	saveHandler: PropTypes.func,
	onSortEndHandler: PropTypes.func,
	updateSettingsHandler: PropTypes.func,
}

export default translate('translations')(Responsibility)
